import { UNIT, mainColor } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 2,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 1.25
  },
  body: {
    width: '100%',
    display: 'flex',
    padding: '10px 10px 0px 15px'
  },

  subtitle: { fontWeight: 'bold' },
  designText: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    alignSelf: 'center',
    paddingBottom: '5px'
  },
  paper: { marginTop: UNIT * 0.625, width: '100%' },
  bottomNavig: {
    border: '1px solid #f2efef',
    height: `${UNIT * 13.5625}%`,
    borderRadius: UNIT * 0.375,
    marginTop: UNIT * 0.75,
    maxWidth: '100%',
  },
  bottomNavigProduct: {
    border: '1px solid #f2efef',
    height: `${UNIT * 17.3125}%`,
    borderRadius: UNIT * 0.375,
    marginTop: UNIT * 0.75,
    maxWidth: '100%',
  },
  iconStyle: {
    marginBottom: UNIT * 0.8125
  },
  horizontalProductIcon: {
    width: UNIT * 6.5625,
    marginBottom: UNIT * 2.1875,
    marginTop: UNIT * 1.375
  },
  verticalProductIcon: {
    width: UNIT * 3.25,
    marginBottom: UNIT * 1.375
  },
  buttonStyle: {
    width: '100%'
  },
  divStyle: {
    height: UNIT * 4.375
  },
  inputStyle: {
    width: '100%',
    marginTop: UNIT * 0.625
  },
  cropStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: UNIT * 0.625,
    marginLeft: -UNIT * 0.8125,
    marginBottom: UNIT * 0.625
  },
  space: {
    marginTop: UNIT * 0.125,
    height: UNIT * 40.9375
  },
  helpIcon: {
    color: '#009973',
    fontSize: UNIT * 1.1875
  },
  paperStyle: {
    padding: UNIT * 0.625,
    borderRadius: '0px 16px 16px 0px!important',
    margin: '0px -18px',
    height: UNIT * 50.9375
  },
  iframeStyle: {
    padding: '0px 4px 0px 0px!important',
    borderRadius: UNIT
  },
  viewStyle: {
    borderRadius: '16px 0px 0px 0px'
  },
  marginStyle: {
    marginTop: -UNIT * 0.625
  },
  crop: {
    width: '100%',
    height: UNIT * 10.1875,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkOutStyle: {
    color: '#f2efef',
    fontSize: UNIT * 1.8125,
    marginTop: -UNIT * 0.1875
  }
});
